<div class="content">
  <hr/>
  <hr/>

  <ion-label class="title">Histórico de Alterações</ion-label>

  <ion-card *ngFor="let log of logs" >
    <ion-card-header>
      <ion-label *ngIf="log.executor.funcionario"><b>Alterado por:</b>&nbsp;{{log.executor.funcionario.nome}} {{log.executor.funcionario.sobrenome}}</ion-label>
      <ion-label *ngIf="log.executor.candidato"><b>Alterado por:</b>&nbsp;{{log.executor.candidato.nome}} {{log.executor.candidato.sobrenome}}</ion-label>
      <br>
      <ion-label><b>Data do Evento:</b>&nbsp;{{log.dataExecucao | date : 'dd/MM/yyyy HH:mm:ss'}}</ion-label>
      <br>
      
    </ion-card-header>
    <ion-card-content>
      <quill-editor [(ngModel)]="log.descricaoOperacao" disabled="true" style="height: 50px;">
        <div quill-editor-toolbar style="display:none"></div>
      </quill-editor>
    </ion-card-content>
  </ion-card>

  <hr/>
  <hr/>
  <hr/>
  
</div>

<ion-item *ngIf="logs.length===0" class="empty-list-message">
  <ion-icon name="warning-outline"></ion-icon>
  <ion-label>&nbsp;&nbsp;Não há histórico de alterações</ion-label>
</ion-item>